export default "__VITE_ASSET__C2_P163X__"